import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./models/userInfo";

export const store = configureStore({
  reducer: {
    user: userReducer,
  },
});
